module.exports = __webpack_public_path__ + "static/media/letter_a.cfa45ed6.m4a";